import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function updateCardCvs(params) {
    const { baseUrl, requestBrand, cardId, cvsNumber, ...rest } = params;

    invariant(baseUrl, 'baseUrl is a required param of updateCardCvs()');
    invariant(requestBrand, 'requestBrand is a required param of updateCardCvs()');
    invariant(cardId, 'cardId is a required param of updateCardCvs()');
    invariant(cvsNumber, 'cvsNumber is a required param of updateCardCvs()');

    const headers = { 'Content-Type': 'application/json', 'YNAP-REQUEST-BRAND': requestBrand };
    const url = `${baseUrl}card-details`;
    const body = JSON.stringify({ cardId, cvsNumber, ...rest });

    return labelRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), 'updateCardCvs');
}
